export default __webpack_public_path__ + "static/Logo_trimmed-90c6bba5797cb21319e76908448ab325.png";